import { Routes } from './routes';

export const crossSellRoutesByType: Record<string, Routes> = {
  treatment: Routes.SPA_TREATMENT_DETAIL,
  'spa-treatment': Routes.SPA_TREATMENT_DETAIL,
  'spa-day': Routes.SPA_DAY_DETAIL,
  facility: Routes.FACILITY_DETAIL,
  'spa-facility': Routes.FACILITY_DETAIL,
  event: Routes.EVENT_DETAIL,
  voucher: Routes.VOUCHER_DETAIL,
  product: Routes.PRODUCT_DETAIL,
};
